var shouldStringify = ['Object', 'Array'];

var msgTypes = require('./msgTypes')();

function getStr(msg) {
  var original = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!msg || original) {
    return msg;
  } else if (shouldStringify.includes(msg.constructor.name)) {
    return JSON.stringify(msg);
  }

  return msg;
}

module.exports = function (type, msg, original) {
  return "".concat(msgTypes[type]).concat(getStr(msg, original)).concat(msgTypes['log']);
};